import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-restriction',
  templateUrl: './restriction.component.html',
  styleUrls: ['./restriction.component.scss']
})
export class RestrictionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
